import { useEffect, useState } from "react";

import { useUserContext } from "../../context/User";
import { updateAdoption } from "../../services/api";
import Button from "../Button";
import { MultiSelect } from "../ui/MultiSelect";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/Select";
import AdoptResult from "./AdoptResult";
import { questions } from "./data";

const AdoptCompatibility = ({ pet, setStageById, adoption }) => {
  const [index, setIndex] = useState(0);
  const [currentQuestions, setCurrentQuestions] = useState([questions[index]]);
  const [currentAnswer, setCurrentAnswer] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [scoreLog, setScoreLog] = useState([]);
  const [finish, setFinish] = useState(false);

  const { user } = useUserContext();

  useEffect(() => {
    if (!adoption) return;

    const data = adoption.compatibility;

    if (!data) return;
    setIndex(data.index || index);
    setCurrentQuestions(data.currentQuestions || currentQuestions);
    setCurrentAnswer(data.currentAnswer || currentAnswer);
    setAnswers(data.answers || answers);
    setScoreLog(data.scoreLog || scoreLog);
    setFinish(data.finish || finish);
  }, [adoption]);

  const onNextQuestionChange = () => {
    const answersUpd = [...answers, ...currentAnswer];
    const scoreLogUpd = calculateScore(answersUpd);

    let finishUpd = finish;
    const newIndex = index + 1;
    let currentQuestionsUpd = currentQuestions,
      currentAnswerUpd = currentAnswer;
    if (questions[newIndex]) {
      currentQuestionsUpd = [questions[newIndex]];
      currentAnswerUpd = [];
    } else {
      finishUpd = true;
    }

    setCurrentQuestions(currentQuestionsUpd);
    setCurrentAnswer(currentAnswerUpd);
    setIndex(newIndex);
    setAnswers(answersUpd);
    setScoreLog(scoreLogUpd);
    setFinish(finishUpd);

    const d = {
      index: newIndex,
      currentQuestions: currentQuestionsUpd,
      currentAnswer: currentAnswerUpd,
      answers: answersUpd,
      scoreLog: scoreLogUpd,
      finish: finishUpd,
    };
    const update = async () => {
      console.log("run AdoptCompatibility UPDATE");
      await updateAdoption(user.accessToken, adoption.id, { compatibility: d });
    };
    void update();
  };

  const finishCompatibility = () => {
    setStageById(3);
  };

  const setAnswer = (name, value) => {
    const excluded = currentAnswer.filter((c) => c.name !== name);
    const updatedAnswers = [...excluded, { name, value }];
    setCurrentAnswer(updatedAnswers);

    const rootQuestion = questions[index];
    if (!rootQuestion.children) return;

    const includeQuestions = rootQuestion.children.reduce((acc, item) => {
      const depName = item.dependency.name;
      const depValue = item.dependency.value;
      if (updatedAnswers.find((a) => a.name === depName && a.value === depValue)) {
        return [...acc, item];
      }
      return acc;
    }, []);

    setCurrentQuestions([rootQuestion, ...includeQuestions]);
  };

  const calculateScore = (answersUpd) => {
    const process = (acc, ans) => {
      const { name, value } = ans;
      const question = questions.find((q) => q.name === name);
      if (!question?.param) return acc;

      const petParam = pet[question.param];
      let adj = 0;
      const adjN = 5;
      switch (name) {
        case "housingSuitability":
          if (petParam === "any") break;
          if (petParam === "large" && value !== "large") adj = adjN;
          // adj = !petParam.find((p) => p === value) ? adjN : adj;
          break;

        case "outdoorSituation":
          if (petParam === "city") break;
          adj = petParam === value ? adj : adjN;
          break;

        case "childrenSuitability":
          if (value === "no") break;
          if (value === "yes" && petParam === "no") adj = adjN;
          break;

        case "dogsSuitability":
          if (petParam === "no" && value === "yes") adj = adjN;
          break;

        case "animalsSuitability":
          if (petParam === "no" && value === "yes") adj = adjN;
          break;

        case "allergySuitability":
          if (petParam === "no" && value === "yes") adj = adjN;
          break;

        case "aloneTolerance":
          adj = parseInt(value) <= parseInt(petParam) ? adj : adjN;
          break;

        case "adaptability":
          if (value === "no") break;
          if (value === "adaptable" && petParam === "no") adj = adjN;
          break;

        case "experience":
          if (value === "yes") break;
          if (value === "some" && petParam !== "yes") break;
          if (value === "no" && petParam === "no") break;
          adj = adjN;
          break;

        case "supportLevel":
          if (petParam === "flexible" || value === "stable") break;
          if (value === "regular" && petParam === "regular") break;
          adj = adjN;
          break;

        // case "groomingNeeds":
        //   adj = parseInt(value) >= parseInt(petParam) ? adj : adjN;
        //   break;

        default:
          adj = petParam === value ? adj : adjN;
          break;
      }
      return [
        ...acc,
        {
          name: question.param,
          answer: ans.value,
          pet: petParam,
          adjustment: adj,
        },
      ];
    };
    return answersUpd.reduce(process, []);
  };

  return (
    <>
      <div className="flex flex-col gap-6">
        <div className="max-w-xl">
          <div className="flex flex-col gap-6 text-center">
            Hi {user.profile?.title}, let’s see if you and {pet.name} are a good match. This quick
            test checks how well your lifestyle fits her needs.
          </div>
        </div>

        {finish && <AdoptResult pet={pet} scoreLog={scoreLog} onFinish={finishCompatibility} />}
        {currentQuestions && !finish && (
          <>
            {currentQuestions.map((currentQuestion) => (
              <div key={currentQuestion.name} className="flex max-w-xl flex-col gap-0 border">
                <div className="border-b-[1px] p-3 font-medium">{currentQuestion.title}</div>
                {currentQuestion.type === "select" && (
                  <div className="relative">
                    <Select
                      onValueChange={(v) => setAnswer(currentQuestion.name, v)}
                      name={currentQuestion.name}
                    >
                      <SelectTrigger className="w-full border-none">
                        <SelectValue placeholder="Select option" />
                      </SelectTrigger>

                      <SelectContent>
                        {currentQuestion.options.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value} desc={opt.desc}>
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>

                    {/* <SelectSimple
                    name={currentQuestion.name}
                    placeholder="Select option"
                    options={currentQuestion.options.map((opt) => [opt.value, opt.label])}
                    value={""}
                    customClasses="border-none"
                    onChange={(v) => setCurrentAnswer(v.currentTarget.value)}
                  /> */}
                  </div>
                )}
                {currentQuestion.type === "radio" && (
                  <div className="relative">
                    <div className="flex gap-[1px]">
                      {currentQuestion.options.map((opt) => (
                        <div
                          className={`flex h-[60px] flex-1 cursor-pointer items-center justify-center transition-all hover:bg-theme-blue-5 hover:text-white ${currentAnswer.find((a) => a.name === currentQuestion.name)?.value === opt.value && "bg-theme-blue-5 text-white"}`}
                          key={opt.value}
                          onClick={() => setAnswer(currentQuestion.name, opt.value)}
                        >
                          {opt.label}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {currentQuestion.type === "multiselect" && (
                  <div className="relative">
                    <MultiSelect
                      options={currentQuestion.options}
                      onValueChange={(v) => setAnswer(currentQuestion.name, v)}
                      className="border-none"
                      // defaultValue={selectedValues}
                    />
                  </div>
                )}
              </div>
            ))}

            <div className="flex justify-between">
              <Button title="Back" disabled theme="secondary" size="medium" onClick={() => ""} />
              <Button
                title={`${index + 1 === questions.length ? "Finish" : "Next Question"}`}
                disabled={currentAnswer.length !== currentQuestions.length}
                theme="dark"
                size="medium"
                onClick={onNextQuestionChange}
              />
            </div>
          </>
        )}
      </div>
      {scoreLog?.length > 0 && (
        <div className="mt-10 flex flex-col flex-col-reverse gap-5 text-sm">
          {scoreLog.map((r) => (
            <div key={r.name + "1"}>
              <div>Name: {r.name}</div>
              <div>Answer: {r.answer}</div>
              <div>Pet: {JSON.stringify(r.pet)}</div>
              <div>Adjustment: {r.adjustment && `-${r.adjustment}`}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AdoptCompatibility;
